// Official WeTravel embedded checkout loader (WeTravel "Book Now" widget).
// Loader: https://cdn.wetravel.com/widgets/embed_checkout.js — the ONLY official script
// for this snippet format. It discovers .wtrvl-checkout_button elements (our branded,
// Inforno-styled CTAs carry the exact Caribou-supplied class + data attributes + href)
// and binds the embedded-checkout overlay to their native click — no synthetic clicks,
// no reverse-engineering. The shared script is never removed (provider listeners).
import { WETRAVEL_EMBED, WETRAVEL_FALLBACK_URL } from "@/lib/thailand";
import { setUiFlag } from "@/lib/uiState";

const SCRIPT_URL = "https://cdn.wetravel.com/widgets/embed_checkout.js";
let state = "idle"; // idle | loading | ready | failed

export function wetravelState() { return state; }
export function wetravelFallback() { window.open(WETRAVEL_FALLBACK_URL, "_blank", "noopener,noreferrer"); }

// Watch for the WeTravel overlay iframe entering/leaving the DOM so site UI
// (sticky CTA, Passport popup, BackToTop) yields while checkout is open.
let observer = null;
let wasOpen = false;
let lastTrigger = null;
function watchOverlay() {
  if (observer || typeof document === "undefined") return;
  const sync = () => {
    // The official loader manages body scroll-lock + mobile view itself; we only
    // track open/closed so Inforno UI (popup, sticky CTA) yields appropriately.
    // Transition-only writes: on any DOM mutation the observer would otherwise
    // overwrite an overlay flag set by the lightbox/planner (owner-found race).
    const open = !!document.querySelector("iframe.wtrvl-ifrm");
    if (open === wasOpen) return;
    wasOpen = open;
    setUiFlag("overlay", open);
    if (open) lastTrigger = document.activeElement;
    else if (lastTrigger) requestAnimationFrame(() => lastTrigger.focus?.());
  };
  observer = new MutationObserver(sync);
  observer.observe(document.body, { childList: true, subtree: true });
}

export function initWeTravel() {
  if (state !== "idle" || typeof document === "undefined") return;
  if (document.querySelector(`script[src="${SCRIPT_URL}"]`)) { state = "ready"; document.dispatchEvent(new Event("DOMContentLoaded", { bubbles: true })); watchOverlay(); return; }
  state = "loading";
  const script = document.createElement("script");
  script.src = SCRIPT_URL;
  script.async = true;
  script.onload = () => {
    state = "ready";
    // The official loader binds its widgets inside a DOMContentLoaded listener; a
    // dynamically-injected script loads after that event, so we re-emit it once to
    // let the official initialization run (buttons are already rendered by then).
    document.dispatchEvent(new Event("DOMContentLoaded", { bubbles: true }));
    watchOverlay();
  };
  script.onerror = () => { state = "failed"; };
  document.head.appendChild(script);
}

export { WETRAVEL_EMBED, WETRAVEL_FALLBACK_URL };
